import find from 'lodash/find';

const extractDefectivenessInfo = (riepilogoStrutturaTable, context) => {
  let tableColumn;

  if (context === 1) {
    tableColumn = 'difettositaStrutturale';
  } else if (context === 2) {
    tableColumn = 'difettositaSismica';
  }

  const firstRowWithNullCondition = find(
    riepilogoStrutturaTable,
    tableRow => tableRow && tableRow[tableColumn] === null
  );

  if (firstRowWithNullCondition) {
    return undefined;
  }

  let worstCondition = undefined;

  riepilogoStrutturaTable?.forEach(tableRow => {
    const defectiveness = tableRow ? tableRow[tableColumn] : undefined;

    if (!worstCondition) {
      worstCondition = defectiveness;
    } else if (defectiveness > worstCondition) {
      worstCondition = defectiveness;
    }
  });

  return worstCondition;
};

export const calculateDifettositaComplessiva = riepilogoStrutturaTable => ({
  difettositaStrutturale: extractDefectivenessInfo(riepilogoStrutturaTable, 1),
  difettositaSismica: extractDefectivenessInfo(riepilogoStrutturaTable, 2),
});
